import React, { SyntheticEvent, useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import * as Styled from './ProductsTableRow.styles';
import Button from '../../../../../../components/Button';
import Counter from '../../../../../../components/Counter';
import AnalogModal from '../../../../../../components/AnalogModal';
import {
  changeCountInProduct,
  changeOperatorCountAnalogInProduct,
  changeOperatorCountInProduct,
  changeCountAnnalogInProduct,
  getCurrentOrderProducts,
  getFromLocalStorage,
  changeVisiblePriceProduct,
  changeVisiblePriceAnalog,
} from '../../../../../../global/helpers';
import * as actions from '../../../../actions';
import { newPriceProduct } from '../../../../../OrdersPage/helpers';
import ConfirmationDeleteProduct from '../../../ConfirmationDeleteProduct';
import closeIcon from '../../../../../../global/media/modal-close-icon.svg';
import CustomCheckbox from '../../../../../../components/CustomCheckbox';
import { UserRole } from '../../../../../OrdersPage/types';
import { StatusType } from '../../../../../../global/types';
import { isDateFresh } from '../../../../../SalesPage/helpers';
import { selectors } from '../../../../reducer';
import EditCheckboxContainer from '../EditCheckboxContainer';
import WoltProposalSearchModal from '../WoltProposalSearchModal';

interface ProductsTableRowProps {
  data: any;
  source: string;
  orderId: string;
  itemIndex: number;
  handleOpenAnalogModal: () => void;
  handleCloseAnalogModal: () => void;
  onCountChange: (price: number) => void;
  isAnalogModalOpen: boolean;
  sku: string;
  editActive: boolean;
  editOperator: boolean;
  updateProductFieldById?: (id: string, field: string, value: any) => void;
  notFilled?: {
    sku: string;
    term: boolean;
    price: boolean;
    diff: boolean;
    analog: boolean;
  };
  userSource?: string;
  isGlovoEdit?: boolean;
  changeGlovoCount?: (
    option: 'plus' | 'minus' | 'set' | 'delete',
    sku: any,
    quantity?: number
  ) => void;
  itemsCount?: number;
  changePartnerProposal?: (
    sku: string,
    proposal: {
      sku: string;
      count_desired: number;
      pharmacy_count: number;
      name: string;
      min_customer_price: number;
      quantity: number;
    } | null
  ) => void;
  sourceCode?: string;
}

const ProductsTableRow = ({
  data,
  itemIndex,
  source,
  handleOpenAnalogModal,
  handleCloseAnalogModal,
  isAnalogModalOpen,
  orderId,
  editActive,
  editOperator,
  onCountChange,
  updateProductFieldById,
  notFilled,
  userSource,
  isGlovoEdit,
  changeGlovoCount,
  itemsCount,
  changePartnerProposal,
  sourceCode,
}: ProductsTableRowProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const userRole = getFromLocalStorage('role');
  const currentOrder = getCurrentOrderProducts();
  const selectorProductTags = useSelector(selectors.productTags);
  const [isVisibleProductPrice, setVisibleProductPrice] = useState<boolean>(
    getFromLocalStorage('selectedOrder')[data.sku]?.visiblePrice
  );
  const [isVisibleAnalogPrice, setVisibleAnalogPrice] = useState<boolean>(
    getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.visiblePrice
  );
  const [isBiggerImg, setIsBiggerImg] = useState<boolean>(false);
  const [dateInput, setDateInput] = useState<string>('');
  const [count, setCount] = useState(Number(data.pharmacyCount));
  const [quantity, setQuantity] = useState(Number(data.quantity));
  const [productTags, setProductTags] = useState<boolean>(false);
  const [analogQuantity, setAnalogQuantity] = useState(
    Number(data?.proposal?.count)
  );
  // eslint-disable-next-line
  const [analogCount, setAnalogCount] = useState(
    getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.pharmacyCount
  );
  // eslint-disable-next-line
  const [isWoltSearchOpen, setIsWoltSearchOpen] = useState<boolean>(false);
  // eslint-disable-next-line
  const [woltSelectedProposal, setWoltSelectedProposal] = useState<{
    sku: string;
    name: string;
    count_desired: number;
    pharmacy_count: number;
    min_customer_price: number;
    quantity: number;
  } | null>(
    data.partnerProposal ?? data.proposal
      ? {
          ...(data.partnerProposal ?? data.proposal),
        }
      : null
  );

  // eslint-disable-next-line
  useEffect(() => {
    setAnalogCount(
      getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.pharmacyCount
    );
  }, [getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.pharmacyCount]);

  // eslint-disable-next-line
  useEffect(() => {
    if (data?.proposal) setAnalogQuantity(Number(data?.proposal?.count));
  }, [data?.proposal && data?.proposal?.count]);

  // eslint-disable-next-line
  useEffect(() => {
    const token = getFromLocalStorage('accessToken');

    if (data) {
      dispatch(
        actions.getProductsTags.request({
          token,
          wereId: data?.were_id?.includes('_DISCOUNT')
            ? data?.were_id?.split('_DISCOUNT')[0]
            : data.were_id,
        })
      );
    }
  }, []);

  // eslint-disable-next-line
  useEffect(() => {
    const wereId = data?.were_id?.includes('_DISCOUNT')
      ? data?.were_id?.split('_')[0]
      : data.were_id;

    const tag = selectorProductTags?.find((tag) => tag.ware_id === wereId);

    if (selectorProductTags && data && tag && tag.tags) {
      const isAI = tag.tags.some((el) => el.name === 'Топ-100 V1 auto');
      if (isAI) {
        setProductTags(true);
      }
    }
  }, [selectorProductTags, data, dispatch]);

  const [deleteConfirmationOpenProduct, setDeleteConfirmationOpenProduct] =
    // eslint-disable-next-line
    useState<boolean>(false);
  const [deleteConfirmationOpenAnalog, setDeleteConfirmationOpenAnalog] =
    // eslint-disable-next-line
    useState<boolean>(false);

  const zeroCount = count === 0;
  const notEnough = count < data.quantity;
  const handleOpen = () => {
    dispatch(actions.setSelectedProduct(data.sku));
    handleOpenAnalogModal();
  };

  // eslint-disable-next-line
  useEffect(() => {
    if (data) {
      setVisibleProductPrice(
        getFromLocalStorage('selectedOrder')[data.sku]?.visiblePrice
      );
    }
  }, [getFromLocalStorage('selectedOrder')[data.sku]?.visiblePrice, data]);

  // eslint-disable-next-line
  useEffect(() => {
    if (data.proposal) {
      setVisibleAnalogPrice(
        getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.visiblePrice
      );
    }
  }, [
    getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.visiblePrice,
    data,
  ]);

  // eslint-disable-next-line
  useEffect(() => {
    if (
      data.proposal &&
      getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.pharmacyCount
    ) {
      setAnalogCount(
        getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.pharmacyCount
      );
    } else Number(data?.proposal?.count);
  }, [
    getFromLocalStorage('selectedOrder')[data.sku]?.proposal?.pharmacyCount,
    data,
  ]);

  // eslint-disable-next-line
  useEffect(() => {
    if (
      userRole === UserRole.OPERATOR ||
      userRole === UserRole.ADMIN ||
      userRole === UserRole.HEAD_OPERATOR ||
      userRole === UserRole.DISPATCHER_B2B
    ) {
      onCountChange(newPriceProduct(Object.values(currentOrder)));
    }
  }, [currentOrder[data.sku]?.currentPrice, currentOrder, userRole]);

  // eslint-disable-next-line
  useEffect(() => {
    if (
      userRole !== UserRole.OPERATOR &&
      userRole !== UserRole.ADMIN &&
      userRole !== UserRole.HEAD_OPERATOR &&
      userRole !== UserRole.DISPATCHER_B2B
    ) {
      onCountChange(newPriceProduct(Object.values(currentOrder)));
    }
  }, [currentOrder[data.sku]?.proposal?.currentPrice, currentOrder, userRole]);

  // eslint-disable-next-line
  useEffect(() => {
    if (isGlovoEdit) {
      setQuantity(data.quantity);
    }
  }, [isGlovoEdit, data.quantity]);

  const resetPartnerProposal = () => {
    setWoltSelectedProposal(data.partnerProposal ?? data.proposal ?? null);
  };

  // eslint-disable-next-line
  useEffect(() => {
    if (isGlovoEdit) {
      resetPartnerProposal();
    }
  }, [isGlovoEdit, data.partnerProposal]);

  const increaseCount = () => {
    const updatedCount = changeCountInProduct('plus', data.sku);
    setCount(updatedCount);
  };
  const decreaseCount = () => {
    const updatedCount = changeCountInProduct('minus', data.sku);
    setCount(updatedCount);
  };

  const increaseCountAnalog = () => {
    const updatedCount = changeCountAnnalogInProduct('plus', data.sku);
    setAnalogCount(updatedCount);
  };
  const decreaseCountAnalog = () => {
    const updatedCount = changeCountAnnalogInProduct('minus', data.sku);
    setAnalogCount(updatedCount);
  };

  const setCountProduct = (count: string | number) => {
    const updatedCount = changeCountInProduct('set', data.sku, Number(count));
    setQuantity(updatedCount);
  };

  const increaseOperatorCount = () => {
    const updatedCount = changeOperatorCountInProduct('plus', data.sku);
    setQuantity(updatedCount);
  };
  const decreaseOperatorCount = () => {
    const updatedCount = changeOperatorCountInProduct('minus', data.sku);
    setQuantity(updatedCount);
  };

  const increaseOperatorCountAnalog = () => {
    const updatedCount = changeOperatorCountAnalogInProduct('plus', data.sku);
    setAnalogQuantity(updatedCount);
  };
  const decreaseOperatorCountAnalog = () => {
    const updatedCount = changeOperatorCountAnalogInProduct('minus', data.sku);
    setAnalogQuantity(updatedCount);
  };

  const setCountOperatorProduct = (count: string | number) => {
    const updatedCount = changeOperatorCountInProduct(
      'set',
      data.sku,
      Number(count)
    );
    setCount(updatedCount);
  };

  const handleChangeProductPriceVisible = (value: boolean) => {
    changeVisiblePriceProduct(currentOrder[data.sku], value);
    setVisibleProductPrice(value);
  };

  const handleChangeAnalogPriceVisible = (value: boolean) => {
    changeVisiblePriceAnalog(currentOrder[data.sku], value);
    setVisibleAnalogPrice(value);
  };

  const productImgClickHandler = () => {
    setIsBiggerImg(!isBiggerImg);
  };
  const product = getFromLocalStorage('selectedOrder')[data.sku] || data;

  const analog = getFromLocalStorage('selectedOrder')[data.sku]?.proposal;

  function removeImgBrokenIcon(event: SyntheticEvent<HTMLImageElement, Event>) {
    const brokenImage = event.target as HTMLImageElement;
    const tagName: string = 'alt';

    const brokenImageAttributeValue = brokenImage.getAttribute(
      tagName
    ) as string;

    const alternateTextFromBrokenImage = document.createTextNode(
      userRole === UserRole.ADMIN ||
        userRole === UserRole.OPERATOR ||
        userRole === UserRole.HEAD_OPERATOR ||
        userRole === UserRole.DISPATCHER_B2B
        ? ''
        : brokenImageAttributeValue
    );

    brokenImage.parentNode?.insertBefore(
      alternateTextFromBrokenImage,
      brokenImage
    );

    brokenImage.parentNode?.removeChild(brokenImage);
  }

  const handleCompare = (str1: string, str2: string) => {
    if (!str1 || !str2) {
      return false;
    }

    const str1Numbers = (str1.match(/\d+([.,]\d+)?/g) || []).sort().join('');

    const str2Numbers = (str2.match(/\d+([.,]\d+)?/g) || []).sort().join('');
    return str1Numbers === str2Numbers;
  };

  const handleSelectWoltProduct = (product: any, qty: number) => {
    const proposal = {
      sku: product.sku,
      name: product.name,
      count_desired: qty,
      pharmacy_count: qty,
      min_customer_price: product.min_customer_price,
      quantity: product.quantity,
    };
    setWoltSelectedProposal(proposal);
    changePartnerProposal?.(data.sku, {
      sku: product.sku,
      name: product.name,
      count_desired: qty,
      pharmacy_count: qty,
      min_customer_price: product.min_customer_price,
      quantity: product.quantity,
    });
  };

  const handleRemoveWoltProposal = () => {
    setWoltSelectedProposal(null);
    changePartnerProposal?.(data.sku, null);
  };

  const isOperatorOrAdmin =
    userRole === UserRole.OPERATOR ||
    userRole === UserRole.ADMIN ||
    userRole === UserRole.HEAD_OPERATOR ||
    userRole === UserRole.DISPATCHER_B2B;

  const isGlovoPharmacist =
    userRole === UserRole.PHARMACIST &&
    ['glovo_user', 'wolt_user'].includes(userSource ?? '');

  const getGlovoErrText = () => {
    if (data.availibilityCount === 0) {
      return t('OrdersPage.OrderDetailedModal.NO_AVAILABILITY_IN_BASE');
    }
    if (data.availibilityCount < data.quantity) {
      return t('OrdersPage.OrderDetailedModal.NOT_ENOUGH_QUANTITY', {
        left: data.availibilityCount,
        difference: data.quantity - data.availibilityCount,
      });
    }
    return '';
  };

  // eslint-disable-next-line
  const customErrTooltip = useCallback(
    (option: 'delete' | 'minus') => {
      if (
        !isGlovoPharmacist ||
        (itemsCount && itemsCount > 1) ||
        (option === 'minus' && userSource === 'wolt_user') ||
        (data.quantity > 1 && option === 'minus')
      )
        return null;

      return (
        <Tooltip
          title={String(
            t('OrdersPage.OrderDetailedModal.CONTACT_SUPPORT', {
              contact:
                userSource === 'glovo_user'
                  ? t('OrdersPage.OrderDetailedModal.CONTACT_GLOVO')
                  : t('OrdersPage.OrderDetailedModal.CONTACT_USER'),
            })
          )}
          placement="right-start"
        >
          <img
            src="/images/client_not_added.png"
            width={20}
            height={20}
            alt="icon"
          />
        </Tooltip>
      );
    },
    [isGlovoPharmacist, itemsCount, data.quantity]
  );

  const getPartnerName = () => {
    switch (userSource) {
      case 'glovo_user':
        return 'Glovo: ';
      case 'wolt_user':
        return 'Wolt: ';
      default:
        return 'Партнер: ';
    }
  };

  return (
    <>
      {product && (
        <>
          <Styled.ProductsTableRow>
            <td
              className={`table-cell item-number   ${
                userRole !== UserRole.OPERATOR &&
                userRole !== UserRole.HEAD_OPERATOR &&
                userRole !== UserRole.ADMIN &&
                userRole !== UserRole.DISPATCHER_B2B &&
                (editActive
                  ? 'item-number-pharmacy'
                  : 'item-number-pharmacy-edit')
              }  ${
                isOperatorOrAdmin &&
                (editOperator
                  ? 'item-number-operator'
                  : 'item-number-operator-edit')
              }`}
            >
              {(isGlovoPharmacist ||
                (userRole === UserRole.ADMIN &&
                  ['glovo_user'].includes(userSource ?? ''))) &&
              (data.availibilityCount === 0 ||
                data.availibilityCount < data.quantity) ? (
                <Tooltip title={getGlovoErrText()} placement="right-start">
                  <img
                    src="/images/client_not_added.png"
                    width={20}
                    height={20}
                    alt="icon"
                  />
                </Tooltip>
              ) : (
                itemIndex
              )}
            </td>
            <td
              className={`table-cell table-cell__info ${
                userRole !== UserRole.OPERATOR &&
                userRole !== UserRole.HEAD_OPERATOR &&
                userRole !== UserRole.ADMIN &&
                userRole !== UserRole.DISPATCHER_B2B &&
                (editActive
                  ? 'table-cell__info-pharmacy'
                  : 'table-cell__info-pharmacy-edit')
              }  ${
                isOperatorOrAdmin &&
                (editOperator
                  ? 'table-cell__info-operator'
                  : 'table-cell__info-operator-edit')
              }  ${
                isOperatorOrAdmin &&
                (handleCompare(data.name, data.productPharmacyName)
                  ? 'table-cell__info-operator'
                  : 'table-cell__info-operator-accent')
              }`}
            >
              <div className={isMobile ? '' : 'grid-block'}>
                <div className="flex-block">
                  <div className="name">{data.name}</div>
                  <div className="manufacturer">{data.manufacturer}</div>
                  {Boolean(data.needsRecipe) && (
                    <div className="needs-recipe">
                      {t(
                        'OrdersPage.OrderDetailedModal.ProductsTable.NEEDS_RECIPE'
                      )}
                    </div>
                  )}
                  {(isOperatorOrAdmin ||
                    userRole === UserRole.PHARMACIST ||
                    userRole === UserRole.MANAGER) && (
                    <>
                      <div onClick={productImgClickHandler}>
                        <img
                          style={{
                            scale: !isBiggerImg ? '1' : '1.3',
                            cursor: 'pointer',
                          }}
                          width="120px"
                          height="120px"
                          src={`https://db-images.object.pscloud.io/optimized_v4_img_small_${
                            data.sku?.includes('_discount')
                              ? data.sku.split('_')[0]
                              : data.sku
                          }.webp`}
                          alt={data.pharmacyName}
                          onError={(event) => removeImgBrokenIcon(event)}
                        />
                      </div>
                      {product && product.needsStrongRecipe && (
                        <div
                          className="needs-recipe"
                          style={{ color: '#ff0000' }}
                        >
                          {t(
                            'OrdersPage.OrderDetailedModal.ProductsTable.NEEDS_STRONG_RECIPE'
                          )}
                        </div>
                      )}
                      {isOperatorOrAdmin && productTags && (
                        <p className="ai-description">
                          {t('OrdersPage.AI_CONNECTED')}
                        </p>
                      )}
                      {product.sku?.includes('discount') &&
                        !isDateFresh(product.sku.split('_')[3]) && (
                          <span className="sale-date-info">
                            {t('OrdersPage.EXPIRES_ON')}
                            {isMobile && <br />}
                            {product.sku.split('_')[3]}
                          </span>
                        )}
                    </>
                  )}
                </div>
                {userRole === UserRole.PHARMACIST ||
                userRole === UserRole.MANAGER ||
                userRole === UserRole.PHARMACY_MANAGER ? (
                  !(
                    isMobile && (
                      <div onClick={productImgClickHandler}>
                        <img
                          style={{
                            scale: !isBiggerImg ? '1' : '1.3',
                            cursor: 'pointer',
                          }}
                          width="120px"
                          height="120px"
                          src={`https://db-images.object.pscloud.io/optimized_v4_img_small_${
                            data.sku?.includes('_discount')
                              ? data.sku.split('_')[0]
                              : data.sku
                          }.webp`}
                          alt={data.pharmacyName}
                          onError={(event) => removeImgBrokenIcon(event)}
                        />
                      </div>
                    )
                  )
                ) : (
                  <div className="name">
                    <div>{data.productPharmacyName}</div>
                  </div>
                )}
              </div>
            </td>
            <td className="flex-container-column">
              <div className="flex-container">
                <div
                  className={`table-cell quantity  ${
                    userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    (editActive
                      ? 'quantity-pharmacy'
                      : 'quantity-pharmacy-edit')
                  }  ${
                    isOperatorOrAdmin &&
                    (editOperator
                      ? 'quantity-operator'
                      : 'quantity-operator-edit')
                  }`}
                >
                  {userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    !isGlovoEdit && <span>{`${data.quantity} шт`}</span>}
                  {isOperatorOrAdmin && editOperator && !isGlovoEdit && (
                    <span>{`${data.quantity} шт`}</span>
                  )}
                  {((isOperatorOrAdmin && !editOperator) || isGlovoEdit) && (
                    <div className="counter">
                      <Counter
                        value={quantity}
                        colorCount={`${zeroCount && 'zero'} ${
                          notEnough && 'not-enough'
                        }`}
                        increaseCount={() =>
                          changeGlovoCount
                            ? changeGlovoCount('plus', data.sku)
                            : increaseOperatorCount()
                        }
                        decreaseCount={() =>
                          changeGlovoCount
                            ? changeGlovoCount('minus', data.sku)
                            : decreaseOperatorCount()
                        }
                        setCountInCart={() =>
                          changeGlovoCount
                            ? changeGlovoCount('set', data.sku, quantity)
                            : setCountOperatorProduct(quantity)
                        }
                        errTooltip={() => customErrTooltip('minus')}
                      />
                    </div>
                  )}
                </div>
                {!isMobile && editActive && (
                  <div
                    className={`table-cell amount  ${
                      userRole !== UserRole.OPERATOR &&
                      userRole !== UserRole.HEAD_OPERATOR &&
                      userRole !== UserRole.ADMIN &&
                      userRole !== UserRole.DISPATCHER_B2B &&
                      (editActive
                        ? ` amount-pharmacy ${
                            userRole !== UserRole.OPERATOR &&
                            userRole !== UserRole.HEAD_OPERATOR &&
                            userRole !== UserRole.ADMIN &&
                            userRole !== UserRole.DISPATCHER_B2B &&
                            editActive &&
                            data.status === StatusType.ON_CLARIFICATION &&
                            'amount-pharmacy-20'
                          }`
                        : 'amount-pharmacy-edit')
                    }   ${
                      isOperatorOrAdmin &&
                      (editOperator
                        ? 'amount-operator'
                        : 'amount-operator-edit')
                    } `}
                  >
                    <div
                      className={
                        isOperatorOrAdmin &&
                        data.promoCode &&
                        data.promoCode.discount_target !== 'delivery'
                          ? 'table-cell__amount-discount'
                          : ''
                      }
                    >
                      {data.amount}
                    </div>
                    {isOperatorOrAdmin &&
                      data.promoCode &&
                      data.promoCode.discount_target !== 'delivery' && (
                        <div>
                          - {data.promoCode.value}{' '}
                          {data.promoCode?.discount_type === 'money'
                            ? '₸'
                            : '%'}
                        </div>
                      )}
                  </div>
                )}
                {isGlovoEdit &&
                  ['wolt_user']?.includes(userSource ?? '') &&
                  !data.proposal && (
                    <button
                      type="button"
                      onClick={() => setIsWoltSearchOpen(true)}
                      style={{
                        padding: '6px 12px',
                        background: woltSelectedProposal
                          ? '#4e9bffff'
                          : '#6B4EFF',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 6,
                        cursor: 'pointer',
                        fontSize: 13,
                      }}
                    >
                      {woltSelectedProposal
                        ? t('OrdersPage.OrderDetailedModal.CHANGE_PROPOSAL') ??
                          'Изменить замену'
                        : t('OrdersPage.OrderDetailedModal.ADD_PROPOSAL') ??
                          'Добавить замену'}
                    </button>
                  )}
                {isWoltSearchOpen && (
                  <WoltProposalSearchModal
                    onClose={() => {
                      setIsWoltSearchOpen(false);
                      resetPartnerProposal();
                    }}
                    onConfirm={() => setIsWoltSearchOpen(false)}
                    productName={data.name}
                    originalTotalPrice={
                      data.currentPrice ?? data.price * data.quantity
                    }
                    selectedProposal={woltSelectedProposal}
                    onSelect={handleSelectWoltProduct}
                    onRemove={handleRemoveWoltProposal}
                    sourceCode={sourceCode ?? ''}
                    isWolt={['wolt_user'].includes(userSource ?? '')}
                  />
                )}
                {isOperatorOrAdmin && (
                  <div
                    className={`table-cell amount   ${
                      isOperatorOrAdmin &&
                      (editOperator
                        ? 'amount-operator'
                        : 'amount-operator-edit')
                    } `}
                  >
                    {/* {data.minPrice === data.avgPrice &&
                    data.avgPrice === data.maxPrice
                      ? data?.avgPrice
                      : `${data?.minPrice}/${data?.avgPrice}/${data?.maxPrice}`} */}
                    {`${data.quantity * data.price} ₸`}
                  </div>
                )}

                {data.partnerPrice && (
                  <div
                    className={`table-cell amount   ${
                      isOperatorOrAdmin && 'amount-operator'
                    } `}
                  >
                    {!isOperatorOrAdmin && (
                      <span style={{ opacity: 0.5, fontWeight: 400 }}>
                        {getPartnerName()}
                      </span>
                    )}
                    {`${data.quantity * data.partnerPrice} ₸`}
                  </div>
                )}

                <div
                  className={`table-cell counter ${
                    userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    (editActive
                      ? `counter-pharmacy ${
                          data.status === StatusType.ON_CLARIFICATION &&
                          'counter-pharmacy-20'
                        }`
                      : 'counter-pharmacy-edit')
                  }  ${
                    isOperatorOrAdmin &&
                    (editOperator
                      ? 'counter-operator'
                      : 'counter-operator-edit')
                  }`}
                >
                  <div
                    className={`counter counter-operator ${
                      zeroCount && 'zero'
                    } ${notEnough && 'not-enough'}`}
                  >
                    {(userRole === UserRole.OPERATOR ||
                      userRole === UserRole.ADMIN ||
                      userRole === UserRole.HEAD_OPERATOR ||
                      userRole === UserRole.DISPATCHER_B2B ||
                      (userRole !== UserRole.OPERATOR &&
                        userRole !== UserRole.ADMIN &&
                        userRole !== UserRole.HEAD_OPERATOR &&
                        userRole !== UserRole.DISPATCHER_B2B &&
                        editActive &&
                        data.status === StatusType.ON_CLARIFICATION)) && (
                      <span>{`${
                        currentOrder[data.sku]?.pharmacyCount ||
                        data.pharmacyCount
                      } шт`}</span>
                    )}
                    {!editActive &&
                      userRole !== UserRole.OPERATOR &&
                      userRole !== UserRole.HEAD_OPERATOR &&
                      userRole !== UserRole.ADMIN &&
                      userRole !== UserRole.DISPATCHER_B2B && (
                        <Counter
                          value={count}
                          colorCount={`${zeroCount && 'zero'} ${
                            notEnough && 'not-enough'
                          }`}
                          increaseCount={increaseCount}
                          decreaseCount={decreaseCount}
                          setCountInCart={setCountProduct}
                        />
                      )}
                  </div>
                </div>

                {!editActive &&
                  userRole !== UserRole.OPERATOR &&
                  userRole !== UserRole.HEAD_OPERATOR &&
                  userRole !== UserRole.ADMIN &&
                  userRole !== UserRole.DISPATCHER_B2B && (
                    <div
                      className={`table-cell amount ${
                        editActive ? 'amount-edit' : 'amount-pharmacy-new-edit'
                      }  ${
                        isOperatorOrAdmin &&
                        (editOperator
                          ? 'amount-operator-new'
                          : 'amount-operator-new-edit')
                      } `}
                    >
                      {`${currentOrder[data.sku]?.currentPrice.toFixed(2)} ₸`}
                    </div>
                  )}
                {!editActive &&
                  userRole !== UserRole.OPERATOR &&
                  userRole !== UserRole.HEAD_OPERATOR &&
                  userRole !== UserRole.ADMIN &&
                  userRole !== UserRole.DISPATCHER_B2B && (
                    <div className="table-cell analog-btn" />
                  )}
                {((!editOperator && isOperatorOrAdmin) || isGlovoEdit) && (
                  <div
                    className={`table-cell amount ${
                      userRole !== UserRole.OPERATOR &&
                      userRole !== UserRole.HEAD_OPERATOR &&
                      userRole !== UserRole.ADMIN &&
                      userRole !== UserRole.DISPATCHER_B2B &&
                      !editActive &&
                      'amount-edit'
                    }  ${
                      isOperatorOrAdmin &&
                      (editOperator
                        ? 'amount-operator-new'
                        : 'amount-operator-new-edit')
                    } `}
                  >
                    <div className="current-price-block">
                      {!isGlovoEdit &&
                        `${currentOrder[data.sku]?.currentPrice?.toFixed(2)} ₸`}
                      {userRole === 'operator' && !editOperator && (
                        <div className="current-price-checkbox">
                          <CustomCheckbox
                            checked={isVisibleProductPrice}
                            onChange={(e) => handleChangeProductPriceVisible(e)}
                            id={data.sku}
                          />
                        </div>
                      )}
                    </div>
                    {((isOperatorOrAdmin && !editOperator) || isGlovoEdit) &&
                      (customErrTooltip?.('delete') ?? (
                        <Styled.ProductDelete>
                          {/* eslint-disable-next-line */}
                          <img
                            src={closeIcon}
                            alt="close icon"
                            onClick={() =>
                              changeGlovoCount
                                ? changeGlovoCount('delete', data.sku)
                                : setDeleteConfirmationOpenAnalog(true)
                            }
                          />
                        </Styled.ProductDelete>
                      ))}
                  </div>
                )}
              </div>

              {!editOperator &&
                !editActive &&
                (userRole === UserRole.PHARMACIST ||
                  userRole === UserRole.MANAGER) &&
                !isMobile && (
                  <EditCheckboxContainer
                    data={data}
                    updateProductFieldById={updateProductFieldById}
                    product={product}
                    dateInput={dateInput}
                    setDateInput={setDateInput}
                    handleCloseAnalogModal={handleCloseAnalogModal}
                    isAnalogModalOpen={isAnalogModalOpen}
                    handleOpenAnalogModal={handleOpen}
                    source={source}
                    orderId={orderId}
                    notFilled={notFilled}
                  />
                )}
            </td>
          </Styled.ProductsTableRow>
          {!editOperator &&
            !editActive &&
            (userRole === UserRole.PHARMACIST ||
              userRole === UserRole.MANAGER) &&
            isMobile && (
              <EditCheckboxContainer
                data={data}
                updateProductFieldById={updateProductFieldById}
                product={product}
                dateInput={dateInput}
                setDateInput={setDateInput}
                handleCloseAnalogModal={handleCloseAnalogModal}
                isAnalogModalOpen={isAnalogModalOpen}
                handleOpenAnalogModal={handleOpen}
                source={source}
                orderId={orderId}
                notFilled={notFilled}
              />
            )}
          {analog && (
            <>
              <Styled.Analog>Аналог</Styled.Analog>
              <Styled.AnalogRow>
                <td
                  className={`table-cell item-number  ${
                    userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    (editActive
                      ? 'item-number-pharmacy'
                      : 'item-number-pharmacy-edit')
                  }  ${
                    (userRole === UserRole.OPERATOR ||
                      userRole === UserRole.HEAD_OPERATOR ||
                      userRole === UserRole.ADMIN ||
                      userRole === UserRole.DISPATCHER_B2B) &&
                    (editOperator
                      ? 'item-number-operator'
                      : 'item-number-operator-edit')
                  }`}
                />
                <td
                  className={`table-cell table-cell__info ${
                    userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    (editActive
                      ? 'table-cell__info-pharmacy'
                      : 'table-cell__info-pharmacy-edit')
                  }  ${
                    (userRole === UserRole.OPERATOR ||
                      userRole === UserRole.HEAD_OPERATOR ||
                      userRole === UserRole.ADMIN ||
                      userRole === UserRole.DISPATCHER_B2B) &&
                    (editOperator
                      ? 'table-cell__info-operator'
                      : 'table-cell__info-operator-edit')
                  }`}
                >
                  <div className="grid-block">
                    <div className="flex-block">
                      <div className="name">{analog.name}</div>
                      <div className="manufacturer">{analog.manufacturer}</div>
                      {Boolean(analog.needsRecipe) && (
                        <div className="needs-recipe">
                          {t(
                            'OrdersPage.OrderDetailedModal.ProductsTable.NEEDS_RECIPE'
                          )}
                        </div>
                      )}
                    </div>
                    <div className="name">{analog.skuName}</div>
                    <div />
                  </div>
                </td>
                <td
                  className={`table-cell quantity  ${
                    userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    (editActive
                      ? 'quantity-pharmacy'
                      : 'quantity-pharmacy-edit')
                  }  ${
                    (userRole === UserRole.OPERATOR ||
                      userRole === UserRole.HEAD_OPERATOR ||
                      userRole === UserRole.ADMIN ||
                      userRole === UserRole.DISPATCHER_B2B) &&
                    (editOperator
                      ? 'quantity-operator'
                      : 'quantity-operator-edit')
                  }`}
                >
                  {userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B && (
                      <span>{`${analogCount} шт`}</span>
                    )}
                  {(userRole === UserRole.OPERATOR ||
                    userRole === UserRole.HEAD_OPERATOR ||
                    userRole === UserRole.ADMIN ||
                    userRole === UserRole.DISPATCHER_B2B) &&
                    editOperator && <span>{`${analogCount} шт`}</span>}
                  {(userRole === UserRole.OPERATOR ||
                    userRole === UserRole.HEAD_OPERATOR ||
                    userRole === UserRole.ADMIN ||
                    userRole === UserRole.DISPATCHER_B2B) &&
                    !editOperator && (
                      <div className="counter">
                        <Counter
                          value={analogQuantity}
                          colorCount={`${zeroCount && 'zero'} ${
                            notEnough && 'not-enough'
                          }`}
                          increaseCount={increaseOperatorCountAnalog}
                          decreaseCount={decreaseOperatorCountAnalog}
                          setCountInCart={setCountOperatorProduct}
                        />
                      </div>
                    )}
                </td>
                <td
                  className={`table-cell amount  ${
                    userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    (editActive
                      ? ` amount-pharmacy ${
                          userRole !== UserRole.OPERATOR &&
                          userRole !== UserRole.HEAD_OPERATOR &&
                          userRole !== UserRole.ADMIN &&
                          userRole !== UserRole.DISPATCHER_B2B &&
                          editActive &&
                          data.status === StatusType.ON_CLARIFICATION &&
                          'amount-pharmacy-20'
                        }`
                      : 'amount-pharmacy-edit')
                  }   ${
                    (userRole === UserRole.OPERATOR ||
                      userRole === UserRole.HEAD_OPERATOR ||
                      userRole === UserRole.ADMIN ||
                      userRole === UserRole.DISPATCHER_B2B) &&
                    (editOperator ? 'amount-operator' : 'amount-operator-edit')
                  } `}
                >
                  {!analog?.amount
                    ? userRole !== UserRole.OPERATOR &&
                      userRole !== UserRole.HEAD_OPERATOR &&
                      userRole !== UserRole.ADMIN &&
                      userRole !== UserRole.DISPATCHER_B2B &&
                      editActive && (
                        <span>
                          {' '}
                          {`${currentOrder[
                            data.sku
                          ].proposal?.currentPrice.toFixed(2)} ₸`}
                        </span>
                      )
                    : data.proposal?.amount}
                </td>
                {(userRole === UserRole.OPERATOR ||
                  userRole === UserRole.HEAD_OPERATOR ||
                  userRole === UserRole.ADMIN ||
                  userRole === UserRole.DISPATCHER_B2B) && (
                  <td
                    className={`table-cell amount   ${
                      (userRole === UserRole.OPERATOR ||
                        userRole === UserRole.HEAD_OPERATOR ||
                        userRole === UserRole.ADMIN ||
                        userRole === UserRole.DISPATCHER_B2B) &&
                      (editOperator
                        ? 'amount-operator'
                        : 'amount-operator-edit')
                    } `}
                  >
                    {data.proposal?.minPrice === data.proposal?.avgPrice &&
                    data.proposal?.avgPrice === data.proposal?.maxPrice
                      ? data?.proposal?.avgPrice
                      : `${data?.proposal?.minPrice}/${data?.proposal?.avgPrice}/${data?.proposal?.maxPrice}`}
                  </td>
                )}
                <td
                  className={`table-cell counter ${
                    userRole !== UserRole.OPERATOR &&
                    userRole !== UserRole.HEAD_OPERATOR &&
                    userRole !== UserRole.ADMIN &&
                    userRole !== UserRole.DISPATCHER_B2B &&
                    (editActive
                      ? ` counter-pharmacy ${
                          data.status === StatusType.ON_CLARIFICATION &&
                          'counter-pharmacy-20'
                        }`
                      : 'counter-pharmacy-edit')
                  }  ${
                    (userRole === UserRole.OPERATOR ||
                      userRole === UserRole.HEAD_OPERATOR ||
                      userRole === UserRole.ADMIN ||
                      userRole === UserRole.DISPATCHER_B2B) &&
                    (editOperator
                      ? 'counter-operator'
                      : 'counter-operator-edit')
                  }`}
                >
                  <div className="counter">
                    {(userRole === UserRole.OPERATOR ||
                      userRole === UserRole.ADMIN ||
                      userRole === UserRole.HEAD_OPERATOR ||
                      userRole === UserRole.DISPATCHER_B2B ||
                      (userRole !== UserRole.OPERATOR &&
                        userRole !== UserRole.HEAD_OPERATOR &&
                        userRole !== UserRole.ADMIN &&
                        userRole !== UserRole.DISPATCHER_B2B &&
                        editActive &&
                        data.status === StatusType.ON_CLARIFICATION)) && (
                      <span>{`${analog.pharmacyCount} шт`}</span>
                    )}
                    {userRole !== UserRole.OPERATOR &&
                      userRole !== UserRole.ADMIN &&
                      userRole !== UserRole.HEAD_OPERATOR &&
                      userRole !== UserRole.DISPATCHER_B2B &&
                      !editActive && (
                        <Counter
                          value={analogCount}
                          colorCount={`${zeroCount && 'zero'} ${
                            notEnough && 'not-enough'
                          }`}
                          increaseCount={increaseCountAnalog}
                          decreaseCount={decreaseCountAnalog}
                          setCountInCart={setCountOperatorProduct}
                        />
                      )}
                  </div>
                </td>
                {!editActive &&
                  userRole !== UserRole.OPERATOR &&
                  userRole !== UserRole.HEAD_OPERATOR &&
                  userRole !== UserRole.ADMIN &&
                  userRole !== UserRole.DISPATCHER_B2B && (
                    <td
                      className={`table-cell amount ${
                        editActive ? 'amount-edit' : 'amount-pharmacy-new-edit'
                      }  ${
                        (userRole === UserRole.OPERATOR ||
                          userRole === UserRole.HEAD_OPERATOR ||
                          userRole === UserRole.ADMIN ||
                          userRole === UserRole.DISPATCHER_B2B) &&
                        (editOperator
                          ? 'amount-operator-new'
                          : 'amount-operator-new-edit')
                      } `}
                    >
                      {`${currentOrder[
                        data.sku
                      ]?.proposal?.currentPrice.toFixed(2)} ₸`}
                    </td>
                  )}
                {userRole !== UserRole.OPERATOR &&
                userRole !== UserRole.HEAD_OPERATOR &&
                userRole !== UserRole.ADMIN &&
                userRole !== UserRole.DISPATCHER_B2B &&
                !editActive ? (
                  <td className="table-cell analog-btn">
                    {((!editActive &&
                      userRole !== UserRole.OPERATOR &&
                      userRole !== UserRole.HEAD_OPERATOR &&
                      userRole !== UserRole.ADMIN &&
                      userRole !== UserRole.DISPATCHER_B2B) ||
                      !editOperator) && (
                      <div style={{ marginTop: '22px' }}>
                        <Styled.AnalogDelete
                          onClick={() => setDeleteConfirmationOpenProduct(true)}
                        >
                          <img src={closeIcon} alt="close icon" />
                        </Styled.AnalogDelete>
                      </div>
                    )}
                    {/* <div className="btn" />{' '} */}
                  </td>
                ) : null}
                {!editOperator &&
                  (userRole === UserRole.OPERATOR ||
                    userRole === UserRole.HEAD_OPERATOR ||
                    userRole === UserRole.ADMIN ||
                    userRole === UserRole.DISPATCHER_B2B) && (
                    <td
                      className={`table-cell amount ${
                        userRole !== UserRole.OPERATOR &&
                        userRole !== UserRole.ADMIN &&
                        userRole !== UserRole.DISPATCHER_B2B &&
                        userRole !== UserRole.DISPATCHER_B2B &&
                        !editActive &&
                        'amount-edit'
                      }  ${
                        (userRole === UserRole.OPERATOR ||
                          userRole === UserRole.HEAD_OPERATOR ||
                          userRole === UserRole.ADMIN ||
                          userRole === UserRole.DISPATCHER_B2B) &&
                        (editOperator
                          ? 'amount-operator-new'
                          : 'amount-operator-new-edit')
                      } `}
                    >
                      <div className="current-price-block">
                        {`${currentOrder[
                          data.sku
                        ]?.proposal?.currentPrice.toFixed(2)} ₸`}
                        {(userRole === UserRole.OPERATOR ||
                          userRole === UserRole.HEAD_OPERATOR ||
                          userRole === UserRole.ADMIN ||
                          userRole === UserRole.DISPATCHER_B2B) &&
                          !editOperator && (
                            <div className="current-price-checkbox">
                              <CustomCheckbox
                                checked={isVisibleAnalogPrice}
                                onChange={(e) =>
                                  handleChangeAnalogPriceVisible(e)
                                }
                                id={analog.sku}
                              />
                            </div>
                          )}
                      </div>
                      {((!editActive &&
                        userRole !== UserRole.OPERATOR &&
                        userRole !== UserRole.HEAD_OPERATOR &&
                        userRole !== UserRole.ADMIN &&
                        userRole !== UserRole.DISPATCHER_B2B) ||
                        !editOperator) && (
                        <Styled.AnalogDelete>
                          {/* eslint-disable-next-line */}
                          <img
                            src={closeIcon}
                            alt="close icon"
                            onClick={() =>
                              setDeleteConfirmationOpenProduct(true)
                            }
                          />
                        </Styled.AnalogDelete>
                      )}
                    </td>
                  )}
              </Styled.AnalogRow>
            </>
          )}
        </>
      )}
      {deleteConfirmationOpenAnalog && (
        <ConfirmationDeleteProduct
          name={data?.name}
          sku={data?.sku}
          onClose={() => setDeleteConfirmationOpenAnalog(false)}
          analog={false}
          data={data}
        />
      )}
      {deleteConfirmationOpenProduct && (
        <ConfirmationDeleteProduct
          name={data.proposal?.name}
          sku={data?.sku}
          onClose={() => setDeleteConfirmationOpenProduct(false)}
          analog
        />
      )}
    </>
  );
};

export default ProductsTableRow;
